import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable camelcase */

import { isZipMandatory, isCountryWithNoZipcode, invalidZipcode } from './ZipUtil';
import * as PostalCodes from 'postal-codes-js';
import { getAddress } from '../api/index';
import { trimObjectKeyValues } from './TrimObjects';
export var verifyMinimalAddress = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address, regexValidation, debug) {
    var _ref2, city, state, zipCode, countryISO;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = trimObjectKeyValues(JSON.stringify(address)), city = _ref2.city, state = _ref2.state, zipCode = _ref2.zipCode, countryISO = _ref2.countryISO;
          if (!(!countryISO || countryISO && countryISO.length !== 2)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", false);
        case 5:
          if (!(debug !== null && debug !== void 0 && debug.allowInvalidZipcodes)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", true);
        case 9:
          if (!(!regexValidation && !isZipMandatory(countryISO))) {
            _context.next = 13;
            break;
          }
          return _context.abrupt("return", true);
        case 13:
          if (!isCountryWithNoZipcode(countryISO)) {
            _context.next = 17;
            break;
          }
          return _context.abrupt("return", true);
        case 17:
          if (!(!zipCode && isZipMandatory(countryISO))) {
            _context.next = 19;
            break;
          }
          return _context.abrupt("return", false);
        case 19:
          return _context.abrupt("return", isValidAddress({
            zipCode: zipCode,
            countryISO: countryISO,
            city: city,
            state: state
          }));
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function verifyMinimalAddress(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var getcityStateData = function getcityStateData(zipCode, countryISO) {
  var params = {
    zipcode: zipCode,
    country: countryISO
  };
  return getAddress(params).then(function (result) {
    return result.data;
  });
};
export var isValidAddress = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var zipCode, countryISO, city, state, response, success, city_states;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          zipCode = _ref3.zipCode, countryISO = _ref3.countryISO, city = _ref3.city, state = _ref3.state;
          if (zipCode) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", false);
        case 3:
          if (validateZipByRegex(countryISO, zipCode)) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", false);
        case 5:
          _context2.next = 7;
          return getcityStateData(zipCode, countryISO);
        case 7:
          response = _context2.sent;
          if (response) {
            _context2.next = 10;
            break;
          }
          return _context2.abrupt("return", true);
        case 10:
          success = response.success, city_states = response.city_states; // this just means that zipcode regex was valid but api could not find any city or state match
          if (success) {
            _context2.next = 13;
            break;
          }
          return _context2.abrupt("return", true);
        case 13:
          if (!city_states) {
            _context2.next = 19;
            break;
          }
          if (!(countryISO.toUpperCase() === 'US')) {
            _context2.next = 18;
            break;
          }
          return _context2.abrupt("return", !!city_states.some(function (currentObj) {
            var _currentObj$city, _currentObj$state_abb, _currentObj$state;
            return ((_currentObj$city = currentObj.city) === null || _currentObj$city === void 0 ? void 0 : _currentObj$city.toLowerCase()) === (city === null || city === void 0 ? void 0 : city.toLowerCase()) || ((_currentObj$state_abb = currentObj.state_abbreviation) === null || _currentObj$state_abb === void 0 ? void 0 : _currentObj$state_abb.toLowerCase()) === (state === null || state === void 0 ? void 0 : state.toLowerCase()) || ((_currentObj$state = currentObj.state) === null || _currentObj$state === void 0 ? void 0 : _currentObj$state.toLowerCase()) === (state === null || state === void 0 ? void 0 : state.toLowerCase());
          }));
        case 18:
          return _context2.abrupt("return", !!city_states.some(function (currentObj) {
            var _currentObj$city2, _currentObj$state2;
            return ((_currentObj$city2 = currentObj.city) === null || _currentObj$city2 === void 0 ? void 0 : _currentObj$city2.toLowerCase()) === (city === null || city === void 0 ? void 0 : city.toLowerCase()) || ((_currentObj$state2 = currentObj.state) === null || _currentObj$state2 === void 0 ? void 0 : _currentObj$state2.toLowerCase()) === (state === null || state === void 0 ? void 0 : state.toLowerCase());
          }));
        case 19:
          return _context2.abrupt("return", false);
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function isValidAddress(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var verifyMandatoryZipcodeByRegex = function verifyMandatoryZipcodeByRegex(countryISO, zipCode) {
  if (!isZipMandatory(countryISO)) return true;
  return validateZipByRegex(countryISO, zipCode);
};
export var validateZipByRegex = function validateZipByRegex(countryISO, zipCode) {
  if (invalidZipcode(zipCode, countryISO)) {
    return false;
  }

  // NPM package postal-codes does not validate UM equivalent to US
  // https://en.wikipedia.org/wiki/List_of_postal_codes

  var isValid;
  if (countryISO === 'UM') {
    //@ts-ignore
    isValid = PostalCodes.validate('US', zipCode);
  } else {
    //@ts-ignore
    isValid = PostalCodes.validate(countryISO, zipCode);
  }

  //Unfortunately, the npm postal-codes-js returns either true or a string error
  //message (which is also truthy) which is why we must explicitly check for true
  if (isValid === true) {
    return true;
  }
  return false;
};
export var verify = function verify(_ref5) {
  var type = _ref5.type,
    address = _ref5.address,
    regexValidation = _ref5.regexValidation,
    callback = _ref5.callback,
    debug = _ref5.debug;
  if (type === 'minimal') {
    Promise.resolve(verifyMinimalAddress(address, regexValidation, debug).then(function (result) {
      callback(result);
    }));
  } else if (type === 'zipByRegex') {
    var countryISO = address.countryISO,
      zipCode = address.zipCode;
    callback(verifyMandatoryZipcodeByRegex(countryISO, zipCode));
  } else {
    callback(false);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/utils/VerifyAddressUtils.js
// module id = 4519
// module chunks = 11